<app-header icon="back" title="_EditParticipantInfoHeader_" backText="_Details_" showNav="false"></app-header>
<!-- <app-header icon="back" title="_EditParticipantInfoHeader_" backText="_Details_" showNav="false" changed="{{changedVal}}"></app-header> -->
<div class="edit-participant-info-container body-container">
  <app-add-edit-participant-info mode="edit"></app-add-edit-participant-info>
</div>
